import {create_buffer} from './webgl';
import {RenderTexture} from './webgl-extra';
import {use_program} from './shader-utils';

// poision disk tap offsets for dof_poisson
var POISSON_DISK = new Float32Array([
     0.000000,  0.000000,
     0.527837, -0.085868,
    -0.040088,  0.536087,
    -0.670445, -0.179949,
    -0.419418, -0.616039,
     0.440453, -0.639399,
    -0.757088,  0.349334,
     0.574619,  0.685879,
]);

export function PostProc() {
    this.rtmain = [
        new RenderTexture(128, 128, true),
        new RenderTexture(128, 128, false),
    ];
    this.rtlow = [
        new RenderTexture(128, 128, false),
        new RenderTexture(128, 128, false),
    ];
    this.buf_quad = create_buffer(gl.ARRAY_BUFFER, [0, 0, 1, 0, 0, 1, 1, 1]);
    this.useBlur = true;
    this.useDoF = true;
}

PostProc.prototype._checkResize = function(env) {
    // check size and resize render textures,
    const mainW = env.camera.viewport[2];
    const mainH = env.camera.viewport[3];
    if (this.rtmain[0].width === mainW && this.rtmain[0].height == mainH)
        return;

    // why the multiple of 16?
    //mainW = Math.max(1, mainW >> 4) << 4;
    //mainH = Math.max(1, mainH >> 4) << 4;
    
    // half-size for blur
    // XXX does kind of work at 1/4 size. a bit flashy,
    // but bloom is bigger.

    const SHIFT = 1;
    const blurW = mainW >> SHIFT;
    const blurH = mainH >> SHIFT;

    this.rtmain[0].resize(mainW, mainH);
    this.rtmain[1].resize(mainW, mainH);

    this.rtlow[0].resize(blurW, blurH);
    this.rtlow[1].resize(blurW, blurH);

    console.log('postproc: resize', mainW, mainH);
};

// PostProc.prototype.drawBloom = function(env) {
//     var pgm = this.programs.bloom.use();
//     var tex = this.rtlow[0].texture;
//     var buf_quad = this.buf_quad;
//     var params = env.params;
//
//     gl.disable(gl.DEPTH_TEST);
//     gl.enable(gl.BLEND);
//     gl.blendFunc(gl.ONE, gl.ONE);
//
//     pgm.uniformSampler2D('texture', tex);
//     var c = env.params.bloom.amount;
//     pgm.uniform3f('color', c, c, c+0.1);
//
//     webgl.bindVertexBuffer(quad);
//     pgm.vertexAttribPointer('coord', 2, gl.FLOAT, false, 0, 0);
//     gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
//
//     gl.disable(gl.BLEND);
// };
//
PostProc.prototype.draw = function(env, drawScene) {
    var rtmain = this.rtmain;
    var rtlow = this.rtlow;
    var buf_quad = this.buf_quad;
    var params = env.params;

    // maybe resize render textures
    this._checkResize(env);

    // render to main buffer
    rtmain[0].render(function() {
        gl.clearColor(0, 0, 0, 1);
        gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);
        drawScene(env);
    });

    gl.disable(gl.DEPTH_TEST);
    gl.disable(gl.BLEND);
    gl.bindBuffer(gl.ARRAY_BUFFER, buf_quad);

    // fxaa
    rtmain[1].render(function() {
        const pgm = use_program('fxaa');
        if (!pgm) return;

        pgm.vertexAttribPointer('aCoord', 2, gl.FLOAT, false, 0, 0);
        pgm.uniformSampler2D('uTexColor', rtmain[0].texture);
        pgm.uniform2f('uResolution', rtmain[0].width, rtmain[0].height);
        pgm.uniform1i('uEnable', params.get_value('fxaa_enable'));
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    });

    // downsample
    rtlow[0].render(function() {
        const pgm = use_program('dof_downsample');
        if (!pgm) return;

        pgm.vertexAttribPointer('aCoord', 2, gl.FLOAT, false, 0, 0);
        pgm.uniformSampler2D('uTexColor', rtmain[1].texture);
        pgm.uniform2f('uTexelSize', 1/rtmain[1].width, 1/rtmain[1].height);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    });

    if (1 && this.useBlur) {
        // blur
        var pgm = use_program('dof_blur');
        if (!pgm) return;

        pgm.vertexAttribPointer('aCoord', 2, gl.FLOAT, false, 0, 0);

        var texelSize = [
            1/rtlow[0].width,
            1/rtlow[0].height,
            ];

        var blurCount = 1;
        for (var i = 0; i < blurCount; ++i) {
            // horizontal
            pgm.uniformSampler2D('uTexColor', rtlow[0].texture);
            pgm.uniform2f('uTexelStep', texelSize[0], 0);
            rtlow[1].render(function() {
                gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
            });

            // vertical
            pgm.uniformSampler2D('uTexColor', rtlow[1].texture);
            pgm.uniform2f('uTexelStep', 0, texelSize[1]);
            rtlow[0].render(function() {
                gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
            });
        }
    }

    if (this.useDoF) {
        var pgm = use_program('dof_poisson');
        if (!pgm) return;

        pgm.uniform2fv('uPoisson[0]', POISSON_DISK);

        pgm.uniformSampler2D('uTexHigh', rtmain[1].texture);
        pgm.uniform2f('uTexelSizeHigh', 1/rtmain[1].width, 1/rtmain[1].height);

        pgm.uniformSampler2D('uTexLow', rtlow[0].texture);
        pgm.uniform2f('uTexelSizeLow', 1/rtlow[0].width, 1/rtlow[0].height);

        //const max_coc = params.get_value('dof_max_coc');
        //console.log(max_coc);
        //pgm.uniform1f('uMaxCoc', 100);
        //pgm.uniform1f('uRadiusScale', params.get_value('dof_radius_scale'));
        pgm.uniform2f('uParams',
            params.get_value('dof_max_coc'),
            params.get_value('dof_radius_scale'));
        //pgm.uniform1f('uRadiusScale', params.get_value('dof_radius_scale'));

        pgm.vertexAttribPointer('aCoord', 2, gl.FLOAT, false, 0, 0);

        gl.disable(gl.BLEND);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    } else {
        // just blit to screen
        var pgm = use_program('blit');
        if (!pgm) return;

        pgm.uniformSampler2D('uTexColor', rtlow[0].texture);
        pgm.vertexAttribPointer('aCoord', 2, gl.FLOAT, false, 0, 0);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.BLEND);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    }

    if (0) {
        gl.clearColor(0, 0, 0, 1);
        gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.BLEND);

        // just blit to screen
        var pgm = use_program('blit');
        if (!pgm) return;

        pgm.uniformSampler2D('uTexColor', rtlow[0].texture);
        //pgm.uniformSampler2D('uTexColor', rtmain[0].texture);
        pgm.vertexAttribPointer('aCoord', 2, gl.FLOAT, false, 0, 0);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    }
};

PostProc.prototype.draw_layer = function(env, drawScene) {
    var rtmain = this.rtmain;
    var buf_quad = this.buf_quad;
    var params = env.params;

    // render layer to main buffer with depth intact
    rtmain[0].render(function() {
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        drawScene(env);
    });

    gl.disable(gl.DEPTH_TEST);
    gl.disable(gl.BLEND);
    gl.bindBuffer(gl.ARRAY_BUFFER, buf_quad);

    {
        // composite
        var pgm = use_program('composite');
        if (!pgm) return;
        pgm.uniformSampler2D('uTexColor', rtmain[0].texture);
        pgm.vertexAttribPointer('aCoord', 2, gl.FLOAT, false, 0, 0);
        gl.enable(gl.BLEND);
        gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        gl.disable(gl.BLEND);
    }
};
